import React from 'react'
import { BENEFITS } from '@/components/banners/BannerFinancingOffer/constants'
import { Image } from '@/components/ui'
import { formatHighlightedText } from '@/components/ui/HighlightedText'
import { useWebpExtension } from '@/utils/hooks/image'
import { useDeviceType } from '@/utils/hooks/useDeviceType'
import { BannerFinancingOfferForm } from './components/BannerFinancingOfferForm'
import { messages } from './messages'
import type { IBannerFinancingOfferProps } from './types'
import './styles.scss'

export const BannerFinancingOffer: React.FC<IBannerFinancingOfferProps> = props => {
  const { blockId } = props

  const { isDesktop } = useDeviceType()

  const imageExtension = useWebpExtension()

  return (
    <div className="page-wrapper page-wrapper_no-mobile" id={blockId}>
      <div className="bannerFinancingOffer">
        <header className="bannerFinancingOfferHeader">
          <div className="bannerFinancingOfferInfo">
            <div className="bannerFinancingOfferInfo__imageWrapper">
              <div className="bannerFinancingOfferInfo__image">
                <Image
                  src={isDesktop ? `financingOffer/bannerFinancingOffer.${imageExtension}` : 'financingOffer/poleFinanceLogo.svg'}
                  isInStatic
                />
              </div>
            </div>

            <div className="bannerFinancingOfferInfo__content">
              <h3>{formatHighlightedText(messages.title)}</h3>
              {BENEFITS.length > 0 && (
                <div className="bannerFinancingOfferInfo__benefits">
                  {BENEFITS.map(benefit => (
                    <div className="bannerFinancingOfferInfoBenefit" key={`${benefit.label}  ${benefit.value}`}>
                      <div className="bannerFinancingOfferInfoBenefit__label text_small">{benefit.label}</div>
                      <h5 className="bannerFinancingOfferInfoBenefit__value">{benefit.value}</h5>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <BannerFinancingOfferForm />
        </header>
      </div>
    </div>
  )
}
